export const getPreviewContent = () => {
    const $frame = $('#preview-frame');
    
    if (!$frame.length) {
        return '';
    }

    const $content = $frame.contents();
    const $container = $content.find('#scaled-container');

    if ($container) {
        return $container.get(0).innerHTML;
    }

    return $content.find('body').get(0).innerHTML;
}
